import { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import Utility from '../../Utility/Utility';
import Slider from "react-slick";
import UpcominMatches from "../Match/components/UpcominMatches";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {
	getPlayerListApi,
	playerCreateApi,
	playerStatusApi
} from "./TeamController";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";
import PrevArrow from "../Components/PrevArrow";
import NextArrow from "../Components/NextArrow";
import MatchList from "../Match/components/MatchList";
import { getMatchListApi } from "../Match/MatchController";

const PlayerManagement = () => {

	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [playerList, setPlayerList] = useState([]);

	const { language } = useSelector((state) => state.language);
	const { userDetails, token, userType } = useSelector((state) => state.user);
	console.log("userDetailsuserDetailsuserDetails", userDetails)
	const [matchList, setMatchList] = useState([]);

	const [playerData, setPlayerData] = useState({
		fullName: "",
		email: "",
		password: "",
		position: ["Goalkeeper"],
	})
	const [playerDataError, setPlayerDataError] = useState({
		fullName: "",
		email: "",
		password: "",
	});

	useEffect(() => {
		getPlayerList();
		getMatchList();
	}, []);

	const getPlayerList = () => {
		try {
			dispatch(loaderStateTrue());
			getPlayerListApi()
				.then((response) => {
					let responseData = response.data || [];
					setPlayerList(responseData);
					dispatch(loaderStateFalse());
				})
				.catch((error) => {
					console.log(error);
					dispatch(loaderStateFalse());
				});
		} catch (error) {
			console.log(error);
			dispatch(loaderStateFalse());
		}
	};

	const getMatchList = () => {
		try {
			dispatch(loaderStateTrue());
			getMatchListApi()
				.then((response) => {
					let responseData = response.data?.result || [];
					console.log("responseDataresponseDataresponseData", responseData)
					setMatchList(responseData);
					dispatch(loaderStateFalse());
				})
				.catch((error) => {
					console.log(error);
					dispatch(loaderStateFalse());
				});
		} catch (error) {
			console.log(error);
			dispatch(loaderStateFalse());
		}
	};

	const settings = {
		dots: false,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: <PrevArrow />,
		nextArrow: <NextArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: { slidesToShow: 1 }
			},
			{
				breakpoint: 640,
				settings: { slidesToShow: 1 }
			}
		]
	};

	const validateRegister = () => {
		let valid = true;
		if (playerData.fullName.trim() === "") {
			valid = false;
			setPlayerDataError({ ...playerDataError, fullName: t('requiredField') });
		} else {
			setPlayerDataError({ ...playerDataError, fullName: "" });
		}
		if (playerData.email.trim() === "") {
			valid = false;
			setPlayerDataError({ ...playerDataError, email: t('requiredField') });
		} else if (playerData.email.trim() !== "") {
			let expr = /^([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
			if (!expr.test(playerData.email.trim())) {
				valid = false;
				setPlayerDataError({ ...playerDataError, email: t('validEmail') });
			} else {
				setPlayerDataError({ ...playerDataError, email: "" });
			}
		}
		if (playerData.password.trim() === "") {
			valid = false;
			setPlayerDataError({ ...playerDataError, password: t('requiredField') });
		} else {
			setPlayerDataError({ ...playerDataError, password: "" });
		}
		return valid;
	}

	const resetModal = () => {
		setPlayerData({
			name: "",
			email: "",
			password: "",
			position: "",
		});

		setPlayerDataError({
			name: "",
			email: "",
			password: "",
			position: "",
		});

		setSelected([]);     // position reset
		setIsOpen(false);    // dropdown close
	};


	const handleRegister = () => {
		console.log(playerData);
		let valid = validateRegister();
		if (valid) {
			let data = {
				fullName: playerData.fullName,
				email: playerData.email,
				password: playerData.password,
				position: selected.map(item => item.code)
			}
			dispatch(loaderStateTrue());
			playerCreateApi(data).then(async (response) => {
				console.log(response);
				if (response.status) {
					getPlayerList();
					setPlayerData({
						name: "",
						email: "",
						password: "",
						position: "",
					})
					setPlayerDataError({
						name: "",
						email: "",
						password: "",
						position: "",
					})

					// reset form fields
					resetModal();

					// will SUCCESS modal close
					closeModal();

					Utility.toastNotifications(response.message, 'Success', 'success');
				} else {
					setPlayerDataError({
						name: "",
						email: "",
						password: "",
						position: "",
					})
					Utility.toastNotifications(response.message, 'Error', 'error');
				}
				dispatch(loaderStateFalse());
			}).catch((error) => {
				console.log(error);
				dispatch(loaderStateFalse());
			});
		}
	}

	const handlePlayerStatus = (playerId) => {
		dispatch(loaderStateTrue());
		playerStatusApi(playerId).then(async (response) => {
			console.log(response);
			if (response.status) {
				Utility.toastNotifications(response.message, 'Success', 'success');
			} else {
				Utility.toastNotifications(response.message, 'Error', 'error');
			}
			dispatch(loaderStateFalse());
		}).catch((error) => {
			console.log(error);
			dispatch(loaderStateFalse());
		});
	}

	const [isOpen, setIsOpen] = useState(false);
	const [selected, setSelected] = useState([]);

	const dropdownRef = useRef(null);

	// ==== Outside Click Handler ====
	useEffect(() => {
		const handleClickOutside = (e) => {
			if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleSelect = (item) => {
		if (!selected.some((s) => s.code === item.code)) {
			setSelected([...selected, item]);
		}
		setIsOpen(false);
	};

	const handleRemove = (code) => {
		setSelected(selected.filter((s) => s.code !== code));
	};

	const positionList = [
		{ code: "Goalkeeper", name: "Goalkeeper" },
		{ code: "Defender", name: "Defender" },
		{ code: "Midfielder", name: "Midfielder" },
		{ code: "Striker", name: "Striker" },
	];


	const [open, setOpen] = useState(false);

	const openModal = () => {
		setOpen(true);
		document.body.classList.add("modal-open");
	};

	const closeModal = () => {
		setOpen(false);
		document.body.classList.remove("modal-open");
	};

	const [activeTab, setActiveTab] = useState("tab1");
	const tabs = [
		{ id: "tab1", label: "Statistiques" },
		{ id: "tab2", label: "Escouades" },
		{ id: "tab3", label: "Information" },
	];

	const topScorers = [
		{
			rank: "#1",
			name: "Kamory Doumbia",
			image: "assets/images/players-list/1.png",
			rating: 4.5,
			goals: 6,
		},
		{
			rank: "#2",
			name: "Player Two",
			image: "assets/images/players-list/2.png",
			rating: 4.2,
			goals: 5,
		},
		{
			rank: "#3",
			name: "Player Three",
			image: "assets/images/players-list/3.png",
			rating: 4.0,
			goals: 4,
		},
	];

	const assists = [
		{
			rank: "#1",
			name: "Kamory Doumbia",
			image: "assets/images/players-list/3.png",
			rating: 4.5,
			ratingColor: "bg-green-500",
			goals: 6,
		},
		{
			rank: "#2",
			name: "Kamory Doumbia",
			image: "assets/images/players-list/4.png",
			rating: 2.5,
			ratingColor: "bg-yellow-500",
			goals: 6,
		},
		{
			rank: "#3",
			name: "Kamory Doumbia",
			image: "assets/images/players-list/5.png",
			rating: 2.5,
			ratingColor: "bg-yellow-500",
			goals: 6,
		},
		{
			rank: "#3",
			name: "Kamory Doumbia",
			image: "assets/images/players-list/6.png",
			rating: 4.5,
			ratingColor: "bg-green-500",
			goals: 6,
		},
		{
			rank: "#3",
			name: "Kamory Doumbia",
			image: "assets/images/players-list/4.png",
			rating: 4.5,
			ratingColor: "bg-green-500",
			goals: 6,
		},
	];

	return (
		<main className="main p-4 relative">
			<div className="flex flex-col">
				<div className="flex flex-wrap items-start gap-y-6 -mx-2">
					<div className="lg:w-4/6 w-full px-2">
						<div className="space-y-5">
							<div className="relative text-white">
								<div className="rounded-xl absolute inset-0 bg-gradient-to-b from-[#1B3594] to-[#1A215A] overflow-hidden">
									<div className="absolute -skew-x-[20deg] w-[14vw] top-0 -right-12 bottom-0 bg-[#1B3594] before:content-[''] before:absolute before:w-1/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
								</div>
								<div className="relative bg-cover bg-no-repeat bg-center h-full">
									<div className="flex max-sm:flex-wrap">
										<div className="p-5 flex flex-col items-start justify-between [&_h1_strong]:text-primary-500 space-y-3 md:w-2/3 [&_strong]:text-primary-500">
											<div className="h-full flex flex-col items-start gap-y-2">
												<img src="assets/images/league1m.png" alt="" />

												<h4 className="lg:text-3xl md:text-2xl text-xl font-bold uppercase">{userDetails?.team?.name}</h4>

												<ul className="flex flex-wrap gap-1 md:!mt-auto">
													<li className="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
														<span className="opacity-50">1 x</span> 5.50
													</li>
													<li className="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
														<span className="opacity-50">x</span> 3.25
													</li>
													<li className="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
														<span className="opacity-50">2 x</span> 2.13
													</li>
												</ul>
											</div>
										</div>
										<div className="md:w-1/3 lg:-mt-4 text-center pb-5">
											<img src="assets/images/clubs/paris.png" alt="" className="w-full max-w-56 inline-block" />
										</div>
									</div>
								</div>
							</div>

							{/* <div className="relative">
									<div className="relative rounded-xl bg-gray-50 h-full">
											<div className='absolute inset-0 rounded-xl overflow-hidden'>
													<div className="w-[8vw] h-[8vw] rounded-[50%] bg-[#F022AC] blur-[80px] absolute -top-[1vw] -right-[2vw] opacity-80"></div>
													<div className="w-[16vw] h-[16vw] rounded-[50%] bg-[#FB4A4A] blur-[80px] absolute -top-[6vw] right-[5vw]"></div>
													<div className="w-[10vw] h-[10vw] rounded-[50%] bg-[#0198FF] blur-[100px] absolute -bottom-[6vw] right-[15vw]"></div>
											</div>
											<div className="flex max-sm:flex-wrap gap-3 justify-between relative">
													<div className="p-5 flex flex-col items-start justify-center [&_h1_strong]:text-primary-500 space-y-3 [&_strong]:text-primary-500">
															<div className="space-y-2">
																	<h2 className="lg:text-4xl md:text-3xl text-xl font-black uppercase">{userDetails?.team?.name}</h2>
																	<p className='text-base font-medium text-gray-400'>Dummy text of the printing and typesetting industry.</p>
															</div>
													</div>
													<div className="lg:-mt-4 text-center">
															<img src="assets/images/teams.png" alt="" className="w-full inline-block rounded-br-xl" />
													</div>
											</div>
									</div>
							</div> */}

							<div className="flex justify-between items-center gap-3">
								<h3 className="xl:text-2xl text-xl font-extrabold uppercase">{t('league1Ranking')}</h3>
								<select className="form-select font-bold !max-w-[200px]">
									<option value="">{t('season')} 2025/25</option>
									<option value="">{t('season')} 2025/25</option>
								</select>
							</div>

							<ul className="mb-3 nav nav-tabs flex border-b light-border [&>*]:flex-1 [&>*]:nav-item [&>*]:inline-flex [&>*]:justify-center [&>*]:items-center [&>*]:gap-1">
								{tabs.map((tab) => (
									<li
										key={tab.id}
										className={`nav-item ${activeTab === tab.id
											? "active"
											: ""
											}`}
										onClick={() => setActiveTab(tab.id)}
									>
										<button>{tab.label}</button>
									</li>
								))}
							</ul>


							<div className="tab-content">
								{activeTab === "tab1" && (
									<div className="tab-pane space-y-5">
										<div className="flex flex-wrap -mx-2 gap-y-4">
											<div className="xs:w-1/2 w-full px-2">
												<div className="relative h-full">
													<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
													</div>
													<div className="px-5 relative space-y-3 h-full">
														<div className="-mx-4 flex flex-wrap justify-between h-full">
															<div className="w-1/2 p-4 space-y-3">
																<h4 className="lg:text-2xl text-xl font-black uppercase">01</h4>
																<h5 className="lg:text-xl text-lg font-extrabold leading-tight uppercase text-gray-400">Clean sheets</h5>
															</div>
															<div className="w-1/2 px-4 flex justify-end items-start">
																<img src={require("../../assets/images/draps-propres.png")} alt="" className="max-w-32" />
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="xs:w-1/2 w-full px-2">
												<div className="relative h-full">
													<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
													</div>
													<div className="px-5 relative space-y-3 h-full">
														<div className="-mx-4 flex flex-wrap justify-between h-full">
															<div className="w-1/2 p-4 space-y-3">
																<h4 className="lg:text-2xl text-xl font-black uppercase">70.5</h4>
																<h5 className="lg:text-xl text-lg font-extrabold leading-tight uppercase text-gray-400">% average posessiond</h5>
															</div>
															<div className="w-1/2 px-4 flex justify-end items-start">
																<img src={require("../../assets/images/balls-played.png")} alt="" className="max-w-32" />
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="xs:w-1/2 w-full px-2">
												<div className="relative h-full">
													<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
													</div>
													<div className="px-5 relative space-y-3 h-full">
														<div className="-mx-4 flex flex-wrap justify-between h-full">
															<div className="w-1/2 p-4 space-y-3">
																<h4 className="lg:text-2xl text-xl font-black uppercase">91.61</h4>
																<h5 className="lg:text-xl text-lg font-extrabold leading-tight uppercase text-gray-400">% Accurate passes</h5>
															</div>
															<div className="w-1/2 px-4 flex justify-end items-start">
																<img src={require("../../assets/images/possession-moyenne.png")} alt="" className="max-w-32" />
															</div>
														</div>
													</div>
												</div>
											</div>

											{/* <div className="xs:w-1/2 w-full px-2">
														<div className="relative h-full">
																<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
																		<div className="absolute -skew-x-[20deg] w-[10vw] top-0 -right-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
																</div>
																<div className="px-5 relative space-y-3 h-full">
																		<div className="-mx-4 flex flex-wrap justify-between h-full">
																				<div className="w-1/2 p-4 space-y-3">
																						<h4 className="lg:text-2xl text-xl font-black uppercase">88</h4>
																						<h5 className="lg:text-xl text-lg font-extrabold leading-tight uppercase text-gray-400">Duels won</h5>
																				</div>
																				<div className="w-1/2 px-4 flex justify-end items-start">
																						<img src={require("../../assets/images/draps-propres.png")} alt="" className="max-w-32" />
																				</div>
																		</div>
																</div>
														</div>
												</div> */}

											<div className="xs:w-1/2 w-full px-2">
												<div className="relative h-full">
													<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
														<div className="absolute -skew-x-[20deg] w-[10vw] top-0 -right-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
													</div>
													<div className="px-5 relative space-y-3 h-full">
														<div className="-mx-4 flex flex-wrap justify-between h-full">
															<div className="w-1/2 p-4 space-y-3">
																<ul className="flex gap-4">
																	<li className="lg:text-2xl text-xl font-black uppercase flex items-center gap-1">
																		<div className="w-5 h-7 rounded bg-yellow-500"></div> 6
																	</li>
																	<li className="lg:text-2xl text-xl font-black uppercase flex items-center gap-1">
																		<div className="w-5 h-7 rounded bg-red-500"></div> 1
																	</li>
																</ul>
																<h4 className="lg:text-2xl text-xl font-extrabold leading-tight uppercase text-gray-400">Cards</h4>
															</div>
															<div className="w-1/2 px-4 flex justify-end items-end">
																<img src={require("../../assets/images/cartes.png")} alt="" className="max-w-32" />
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div className="space-y-4">
											<h3 className="text-lg font-bold uppercase">Top Scorers</h3>
											<div className="overflow-x-auto">
												<table className="table table-striped table-row-hover w-full">
													<tbody className="divide-y divide-gray-200">
														{topScorers.map((scorer, index) => (
															<tr key={index}>
																<td>
																	<p className="font-semibold font-secondary text-nowrap">
																		{scorer.rank}
																	</p>
																</td>

																<td>
																	<div className="flex max-sm:flex-wrap items-center gap-3">
																		<div className="size-10 rounded-lg overflow-hidden bg-blue-400">
																			<img
																				className="size-full object-cover"
																				src={scorer.image}
																				alt={scorer.name}
																			/>
																		</div>

																		<div>
																			<p className="font-bold uppercase">{scorer.name}</p>
																		</div>
																	</div>
																</td>

																<td>
																	<span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
																		<img
																			src="assets/images/icons/star-fill.svg"
																			alt="Star"
																			width="16"
																			className="icon-white"
																		/>
																		{scorer.rating}
																	</span>
																</td>

																<td className="text-center">
																	<span className="font-bold uppercase">{scorer.goals} Goals</span>
																</td>
															</tr>
														))}
													</tbody>
												</table>
											</div>
										</div>

										<div className="space-y-4">
											<h3 className="text-lg font-bold uppercase">Assists</h3>
											<div className="overflow-x-auto">
												<table className="table table-striped table-row-hover w-full">
													<tbody className="divide-y divide-gray-200">
														{assists.map((player, index) => (
															<tr key={index}>
																<td>
																	<p className="font-semibold font-secondary text-nowrap">
																		{player.rank}
																	</p>
																</td>

																<td>
																	<div className="flex max-sm:flex-wrap items-center gap-3">
																		<div className="size-10 rounded-lg overflow-hidden bg-blue-400">
																			<img
																				className="size-full object-cover"
																				src={player.image}
																				alt={player.name}
																			/>
																		</div>

																		<div>
																			<p className="font-bold uppercase">{player.name}</p>
																		</div>
																	</div>
																</td>

																<td>
																	<span
																		className={`px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full ${player.ratingColor}`}
																	>
																		<img
																			src="assets/images/icons/star-fill.svg"
																			alt="Star"
																			width="16"
																			className="icon-white"
																		/>
																		{player.rating}
																	</span>
																</td>

																<td className="text-center">
																	<span className="font-bold uppercase">{player.goals} Goals</span>
																</td>
															</tr>
														))}
													</tbody>
												</table>
											</div>
										</div>
									</div>
								)}
								{activeTab === "tab2" && (
									<div className="tab-pane space-y-5">
										<button className="w-full px-4 py-2 rounded-xl border border-gray-200 bg-gray-50 !flex justify-start items-center text-left gap-2" onClick={openModal}>
											<div className="size-10 rounded-full border border-gray-200 flex justify-center items-center bg-gradient-to-r from-primary-950 to-primary-500">
												<img
													src="assets/images/icons/plus.svg"
													alt="Add a Player"
													className="icon-white flex-none"
												/>
											</div>
											<div>
												<span className="flex-1 font-secondary lg:text-2xl text-xl uppercase font-black bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent">Add a New Player</span>
												<p className="text-sm font-bold uppercase text-gray-300">Add a New Football Player to Your Squad</p>
											</div>
										</button>

										{open && <div className="modal-backdrop fade show"></div>}

										<div
											className={`modal fade ${open ? "show d-block" : ""}`}
											onClick={closeModal}
										>
											<div
												className="modal-dialog modal-dialog-centered"
												onClick={(e) => e.stopPropagation()}
											>
												<div className="modal-content rounded-xl">
													<div className="absolute inset-0 bg-[#eaede8] overflow-hidden opacity-20">
														<div className="w-[22vw] h-[17vw] rounded-[50%] bg-[#0198FF] blur-[70px] absolute -top-[1vw] right-0 -rotate-[37deg] opacity-80"></div>
														<div className="w-[30vw] h-[18vw] rounded-[50%] bg-[#FB4A4A] blur-[130px] absolute -top-[2vw] left-0 rotate-[50deg]"></div>
													</div>
													<div className="modal-header relative z-1">
														<h5 className="modal-title">Add Player</h5>
														<button className="btn-close" onClick={closeModal}></button>
													</div>

													<div className="modal-body relative z-1">
														<div className="flex flex-wrap gap-y-4 -mx-2">
															<div className="w-full px-2">
																<input type="text" id="name" placeholder={t('name')} className="form-control" onChange={(e) => {
																	setPlayerData({ ...playerData, fullName: e.target.value })
																	setPlayerDataError({ ...playerDataError, fullName: "" });
																}}
																	value={playerData.fullName}
																/>
																<span className="text-red-500">{playerDataError.fullName}</span>
															</div>
															<div className="w-full px-2">
																<input type="email" id="email" placeholder={t('email')} className="form-control" onChange={(e) => {
																	setPlayerData({ ...playerData, email: e.target.value });
																	setPlayerDataError({ ...playerDataError, email: "" });
																}}
																	value={playerData.email}
																/>
																<span className="text-red-500">{playerDataError.email}</span>
															</div>

															<div className="w-full px-2">
																<div className="w-full relative" ref={dropdownRef}>
																	{/* Selected Box */}
																	<div
																		className="border px-4 py-3 rounded-md cursor-pointer bg-white"
																		onClick={() => setIsOpen(!isOpen)}
																	>
																		<span>Select position...</span>
																	</div>

																	{/* Dropdown Menu */}
																	{isOpen && (
																		<div className="absolute z-20 mt-0 bg-white border rounded-lg shadow-lg w-full max-h-56 overflow-auto">
																			{positionList.map((item, index) => (
																				<div
																					key={index}
																					className="flex items-center gap-3 p-2 hover:bg-gray-100 cursor-pointer"
																					onClick={() => handleSelect(item)}
																				>
																					<span className="font-medium">{item.name}</span>
																				</div>
																			))}
																		</div>
																	)}

																	{/* Selected Tags */}
																	<div className="flex gap-1 flex-wrap mt-2">
																		{selected.map((item, index) => (
																			<div
																				key={index}
																				className="flex items-center gap-1 text-white bg-secondary-500 px-3 py-1 rounded-full"
																			>
																				<span>{item.name}</span>

																				<button
																					className="text-red-500 font-bold"
																					onClick={() => handleRemove(item.code)}
																				>
																					<img src="/assets/images/icons/close.svg" alt="close" className="icon-white w-4" />
																				</button>
																			</div>
																		))}
																	</div>
																</div>
																<span className="text-red-500">{playerDataError.position}</span>
															</div>
															<div className="w-full px-2">
																<input type="password" id="password" placeholder={t('password')} className="form-control" onChange={(e) => {
																	setPlayerData({ ...playerData, password: e.target.value })
																	setPlayerDataError({ ...playerDataError, password: "" });
																}}
																	value={playerData.password}
																/>
																<span className="text-red-500">{playerDataError.password}</span>
															</div>
															{/* <div className="md:w-full w-full px-2">
																<button onClick={handleRegister} className="btn btn-primary !inline-flex">
																	<img
																		src="assets/images/icons/plus.svg"
																		alt="Add a Player"
																		className="icon-white flex-none"
																	/>                                                
																	<span className="font-semibold">Add a New Player</span>
																</button>
														</div> */}
														</div>
													</div>

													<div className="modal-footer relative z-1">
														<button className="btn btn-secondary" onClick={closeModal}>
															close
														</button>
														<button onClick={handleRegister} className="btn btn-primary !inline-flex">
															<span className="font-semibold">Add Player</span>
														</button>
													</div>
												</div>
											</div>
										</div>

										<div className="overflow-x-auto space-y-4">
											<table className="table table-striped table-row-hover w-full">
												<thead className="border-b light-border">
													{/* <tr>
																	<th className="text-lg font-bold" colSpan={4}>Defenders - 8</th>
															</tr> */}
													<tr>
														<th className="text-lg font-bold">S.No</th>
														<th className="text-lg font-bold">Player Name</th>
														<th className="text-lg font-bold">Rating</th>
														<th className="text-lg font-bold">Status</th>
													</tr>
												</thead>
												<tbody className="divide-y divide-gray-200">
													{playerList.map((element, index) => (
														<tr key={index} className={`${element?.teamJoinStatus === "approved" ? "opacity-30" : ""}`}>
															<td width={32} className='w-20'>
																<label className="relative inline-flex items-center gap-1.5 cursor-pointer">
																	<span className="font-secondary font-semibold text-nowrap">#1</span>
																</label>
															</td>
															<td>
																<div onClick={() => navigate(`/${language}/fixtures/players`)} className="flex max-sm:flex-wrap items-center gap-3 cursor-pointer">
																	<div className="size-10 rounded-lg overflow-hidden bg-blue-400">
																		<img className="size-full object-cover" src={`${element?.photo || "assets/images/players-list/4.png"}`} alt="" />
																	</div>
																	<div>
																		<p className="font-bold uppercase">{element?.fullName}</p>
																	</div>
																</div>
															</td>
															<td className='text-right'>
																<span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
																	<img src="assets/images/icons/star-fill.svg" alt="Star" width="16" className="icon-white" /> 4.5
																</span>
															</td>
															<td className='text-right'>
																<button onClick={() => handlePlayerStatus(element?._id)} className="btn btn-primary text-nowrap ml-auto">{element?.teamJoinStatus}</button>
															</td>
														</tr>
													))}
													<tr>
														<td width={32} className='w-20'>
															<label className="relative inline-flex items-center gap-1.5 cursor-pointer">
																<span className="font-secondary font-semibold text-nowrap">#1</span>
															</label>
														</td>
														<td>
															<div className="flex max-sm:flex-wrap items-center gap-3">
																<div className="size-10 rounded-lg overflow-hidden bg-blue-400">
																	<img className="size-full object-cover" src="assets/images/players-list/4.png" alt="" />
																</div>
																<div>
																	<p className="font-bold uppercase">Demo Player</p>
																</div>
															</div>
														</td>
														<td className='text-right'>
															<span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
																<img src="assets/images/icons/star-fill.svg" alt="Star" width="16" className="icon-white" /> 4.5
															</span>
														</td>
														<td className='text-right'>
															<button className="btn btn-primary text-nowrap ml-auto">Approve</button>
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								)}
								{activeTab === "tab3" && (
									<div className="tab-pane space-y-5">
										Information
									</div>
								)}
							</div>
						</div>
					</div>
					<div className="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">
						<div className="space-y-5">
							<div className="panel">
								{/* <div className="panel-header w-full flex flex-wrap justify-center items-center gap-3">
												<div className="flex justify-between gap-3 w-full">
														<button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-left.svg" alt="" /></button>
														<h3 className="xl:text-lg text-base font-extrabold uppercase">Lecture en cours</h3>
														<button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-right.svg" alt="" /></button>
												</div>
										</div> */}
								<div className="panel-body w-full space-y-8">
									<div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
										<div className="p-5 relative space-y-3">
											<div className="flex justify-between items-center gap-4 w-full">
												<div className="flex-1 font-secondary lg:text-3xl text-2xl uppercase font-black bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent">sÊrie de victoires</div>
												<div className="flex-none pr-5">
													<span className="flex-1 font-secondary lg:text-5xl text-4xl uppercase font-black ">70%</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="panel rounded-xl border light-border bg-white p-4 space-y-4">
								<div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
									<h3 className="xl:text-lg text-base font-extrabold uppercase">{t('upcomingMatches')}</h3>
									<Link to={'../upcoming-matches'} className="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</Link>
								</div>
								<div className="panel-body w-full">
									<MatchList matchList={matchList} isUpcomming={true} />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</main>
	)
}

export default PlayerManagement